const Editor = require('./component');
const EditorState = require('./state');
const RichUtils = require('./rich');

module.exports = { Editor, EditorState, RichUtils };
